import { render, staticRenderFns } from "./EnglishProfileAiCard.vue?vue&type=template&id=d53f8490&scoped=true"
import script from "./EnglishProfileAiCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishProfileAiCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EnglishProfileAiCard.vue?vue&type=style&index=0&id=d53f8490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53f8490",
  null
  
)

export default component.exports